/**
 * Update modal data
 */
export const MODAL_UPDATE = 'MODAL_UPDATE';

/**
 * Close all modals
 */
export const MODAL_CLOSE_ALL = 'MODAL_CLOSE_ALL';

/**
 * Set api error
 */
export const API_ERROR_SET = 'API_ERROR_SET';


export default {
  MODAL_UPDATE,
  MODAL_CLOSE_ALL,
  API_ERROR_SET,
};



// WEBPACK FOOTER //
// ./src/apps/core/store/types.js